<template>
    <div class="air_ListBox">
        <div class="search-form">
            <el-row type="flex" :gutter="20" align="middle">
                <el-col class="el-col-label" :span="8">
                    <span>原/新票号:</span>
                    <input
                        clearable
                        v-model="searchForm.ticketNumber"
                        @keyup.13="search"
                        @clear="searchClear"
                    >
                </el-col>
                 <el-col class="el-col-label" :span="8">
                    <span>乘客姓名:</span>
                    <input
                        clearable
                        v-model="searchForm.passengerName"
                        @keyup.13="search"
                        @clear="searchClear"
                    >
                </el-col>
                <el-col class="el-col-label" :span="8">
                    <span>改签日期:</span>
                    <el-date-picker
                        v-model="searchForm.startChaDate"
                        :picker-options='selectPickerOptions()'
                        type="date"
                        class="time_box"
                        value-format="yyyy-MM-dd"
                        @change="search"
                    ></el-date-picker>
                </el-col>
            </el-row>
            <el-row :gutter="20" type="flex" align="middle" style="margin-top:10px;">
                <el-col class="el-col-label" :span="8">
                    <span>航司:</span>
                    <el-select
                        clearable
                        placeholder=""
                        v-model="searchForm.airCompanyName"
                        @change="searchClear"
                    >
                        <el-option
                            v-for="item in airlinesList"
                            :key="item.id"
                            :label="item.airCompanyName"
                            :value="item.airlineCode"
                        ></el-option>
                    </el-select>
                </el-col>

            </el-row>
            <div class="btn_box">
                <el-button type="primary" @click="search" size="small">搜索</el-button>
                <el-button  @click="reset" size="small">重置</el-button>
            </div>
        </div>
        <el-row>
            <el-col :span="24">
                <div class="table-nav flex-center">
          <div class="nav-item cursor"
               v-for="(item,index) in changeRecordList"
               :key="index"
               :class="{'nav-item-active':NavItemActive==index}"
               @click="statuSearch(item,index)">
               {{item.text}}
          </div>
                </div>

        <el-table :data="pageData" v-loading="loading" style="width: 100%">
          <el-table-column label="改签新航段" width="200" class-name="fz12">
            <template slot-scope="scope">
               <div
                v-for="(segmentEntity,segmentEntityIndex) in scope.row.newRouteList"
                :key="segmentEntityIndex"
              >
                <p>
                  行程：{{segmentEntity.sCityName}}({{segmentEntity.sCityCode}})-{{segmentEntity.eCityName}}({{segmentEntity.eCityCode}})</p>
                <p>航班号：{{segmentEntity.flightNo}}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="原航段" width="150" class-name="fz12">
            <template slot-scope="scope">
              <div
                v-for="(segmentEntity,segmentEntityIndex) in scope.row.oldRouteList"
                :key="segmentEntityIndex"
              >
                <p>
                  行程：{{segmentEntity.oldSCityName}}({{segmentEntity.oldSCityCode}})-{{segmentEntity.oldECityName}}({{segmentEntity.oldECityCode}})</p>
                <p>航班号：{{segmentEntity.oldFlightNo}}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="乘机人/新票号"  class-name="fz12">
            <template slot-scope="scope">
              <div
                v-for="(passengerEntity,passengerEntityIndex) in scope.row.passengers"
                :key="passengerEntityIndex"
              >{{parseInt(passengerEntityIndex) + 1}}.{{passengerEntity.lastName+'/'+passengerEntity.firstName}}
               <span v-if="passengerEntity.ticketNumber">({{passengerEntity.ticketNumber}})</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="改签时间" class-name="fz12">
            <template slot-scope="scope">
               <span>{{scope.row.appTime}}</span>
            </template>
          </el-table-column>
          <el-table-column label="补款金额" width="150" class-name="fz12">
            <template slot-scope="scope">{{Number(scope.row.realAddMoneyAmount).toFixed(2)}}</template>
          </el-table-column>
          <el-table-column label="状态" width="80" class-name="fz12">
            <template slot-scope="scope">
              {{scope.row.chaStatus==31?'处理中':
              scope.row.chaStatus==32?'待补款':
              scope.row.chaStatus==33?'已补款':
              scope.row.chaStatus==34?'改签完成':
              scope.row.chaStatus==35?'改签失败':
              ''}}</template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100" class-name="fz12">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="setOrdersNo(scope.row.chaOrderId,'airDetails')"
              >查看订单
              </el-button>
                 <el-button
                  type="text"
                  size="mini"
                  v-show="scope.row.chaStatus==32"
                  @click="setOrdersNo(scope.row,'Filling')"
                >支付补款
                </el-button>
            </template>
          </el-table-column>
         </el-table>
                <div style="margin-bottom: 10px;"></div>
                <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                background
                @size-change="handlerSize"
                @current-change="handlerPage"
                :current-page="searchForm.currentPage"
                :page-sizes="[10,20,30,40,50]"
                :page-size="10"
                :page-count="searchForm.pageSize"
                :total="totalCount"
                ></el-pagination>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import scrollTop from '@/lib/common-service/scrollTop'
import {internationalAirLines} from '@/lib/data-service/flight/fligthInternational'
import list from '@/lib/data-service/flight/fligthInternationalAdmin/flight_inter_buyer_manage_order_findChangeList'
export default {
  data() {
    return {
      searchForm: {
        currentPage:1,
        pageSize:10
      },
      totalCount:0,
      flightAirlines: [],
      changeRecordList:[
        {text:'全部',value:''},
        {text:'处理中',value:31},
        {text:'待补款',value:32},
        {text:'已补款',value:33},
        {text:'已改签',value:34},
        {text:'改签失败',value:35}
      ],
      NavItemActive:'',
      pageData:[],
      loading:false,
      airlinesList:[{
          airlineCode: '',
          airCompanyName: '不限',
          airCompanyEnglistName:'',
          airCompanyShortName:'',
          airlineCode:'',
          countryState:''
        }]
    };
  },
  created(){
    this.search()
    this.getAirlines()
  },
  methods: {
    statuSearch(item,index){
       this.NavItemActive = index
       this.searchForm.chaStatus = item.value
       this.search()
    },
    searchClear() {

    },
     // 日期选择
    selectPickerOptions() {
      return {
        disabledDate: time => {
            return time.getTime() > Date.now()
        }
      }
    },
    reset() {
      this.searchForm = {currentPage:1,pageSize:10}
    },
     // 获取航司列表
    getAirlines() {
      internationalAirLines().then(data => {
        // console.log(data)
        let airlinesList = [...this.airlinesList,...data.pageResult.pageData]
        this.airlinesList = airlinesList
      })
    },
    search(pageNum) {
      let data = this.searchForm
      if(typeof pageNum == 'number'){
          data.currentPage = pageNum||1
      }else{
        data.currentPage = 1
      }
      data.startChaDate?data.endChaDate = this.$moment().format('YYYY-MM-DD'):data.endChaDate = ''
      list(data).then(res=>{
        this.pageData = res.pageResult.pageData
        this.totalCount = res.pageResult.totalCount
        scrollTop(500)
      })
    },
    setOrdersNo(item,type){
      switch (type){
           case 'airDetails':
             this.$router.push({name:'air-ticket-admin-international-list-order-detail',
             query:{ordersNo:item,type:'Changing'},params:{refresh:1}})
            break;
           case 'Filling':
             this.$router.push({name:'international-pay',query:{ordersNo:item.orderNo,type:'international',pay:'22',chaOrderId:item.chaOrderId}
             ,params:{refresh:1}})
            break;
          default:
            break;
      }
    },

    handlerSize(val){
      this.searchForm.pageSize = val
      this.search()
    },
    handlerPage(val){
      // this.searchForm.currentPage = val
      this.search(val)
    }
  }
};
</script>

<style lang='less' scoped>
@import "./css/common";
</style>
